import React, { useState, useMemo } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import IconButton from '@material-ui/core/IconButton';
import PowerSettingsNew from '@material-ui/icons/PowerSettingsNew';
import TuneIcon from '@material-ui/icons/Tune';
import Person from '@material-ui/icons/Person';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import BusinessIcon from '@material-ui/icons/Business';

import Typography from '@material-ui/core/Typography';
import Popover from '@material-ui/core/Popover';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ManualButton from 'app/components/ManualButton';
import { makeStyles } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { logOut } from 'app/store/slices/user';

import { useDispatch, useSelector } from 'react-redux';
import { showLoading, hideLoading, setFromLogin } from 'app/store/slices/settings';
import { URLS } from 'app/config/urls';
import { clearServices } from 'app/store/slices/services';
import { SYSTEM_DOC_TYPES } from 'app/utils/constants';

import auth from 'app/api/auth';

import styles from './styles';
const useStyles = makeStyles(styles);

function UserPopover(props) {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const activeCompany = useSelector(state => state.company.activeCompany);

  const user = useSelector(state => state.auth.user);
  const registrationUserInfo = useSelector(state => state.auth.registrationInfo);

  const name = useMemo(() => {
    if (activeCompany.deRazaoSocial) {
      return activeCompany.deRazaoSocial;
    }
    if (activeCompany.nmCompleto) {
      return activeCompany.nmCompleto;
    }
    return user.nmusuario || user.name || user.username;
  }, [activeCompany, user]);

  const email = useMemo(() => {
    if (activeCompany.deEmail) {
      return activeCompany.deEmail;
    }
    return user.email;
  }, [activeCompany, user]);

  const handlePopover = e => {
    setOpen(true);
    setAnchorEl(e.currentTarget);
  };

  //   const handleLangChange = () => setOpen(false);

  const handleLogOut = async () => {
    setOpen(false);
    dispatch(showLoading());
    dispatch(setFromLogin(false));
    await logOut(dispatch);
    history.push(URLS.LOGIN);
    dispatch(hideLoading());
  };

  const goToLogin = () => {
    setOpen(false);
    dispatch(showLoading());
    dispatch(setFromLogin(false));
    dispatch(clearServices());
    history.push(URLS.LOGIN);
    dispatch(hideLoading());
  };

  const goToUsers = () => {
    setOpen(false);
    history.push(URLS.COMPANY_USERS);
  };

  const goToChangePassword = () => {
    setOpen(false);
    props.onProfile();
  };

  const goToChangeCompany = () => {
    setOpen(false);
    history.push(URLS.COMPANY_SELECT);
  };

  const goToCompany = () => {
    setOpen(false);
    history.push(URLS.COMPANY);
  };

  const renderActionsList = classes => {
    return (
      <List component="div" disablePadding>
        {!auth.getToken() && (
          <ListItem button divider onClick={goToLogin}>
            <ListItemIcon>
              <Person className={classes.listItemIcon} />
            </ListItemIcon>
            <ListItemText
              disableTypography
              className={classes.listItemText}
              primary={<FormattedMessage id="LABELS.LOGIN.LOGIN" />}
            />
          </ListItem>
        )}
        {!!auth.getToken() && (
          <>
            {Object.keys(activeCompany).length > 0 && !activeCompany.cdTipoPessoaFisica && (
              <ListItem button divider onClick={goToCompany}>
                <ListItemIcon>
                  <BusinessIcon className={classes.listItemIcon} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  className={classes.listItemText}
                  primary={<FormattedMessage id="LABELS.COMMONS.COMPANY_DATA" />}
                />
              </ListItem>
            )}
            {(Object.keys(activeCompany).length === 0 || activeCompany.cdTipoPessoaFisica) && (
              <ListItem button divider onClick={goToCompany}>
                <ListItemIcon>
                  <Person className={classes.listItemIcon} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  className={classes.listItemText}
                  primary={<FormattedMessage id="LABELS.COMMONS.REQUESTER_DATA" />}
                />
              </ListItem>
            )}
            {registrationUserInfo.boAtivo && (user.boAdmin || registrationUserInfo.admin) && (
              <ListItem button divider onClick={goToUsers}>
                <ListItemIcon>
                  <Person className={classes.listItemIcon} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  className={classes.listItemText}
                  primary={<FormattedMessage id="LABELS.COMMONS.USERS" />}
                />
              </ListItem>
            )}
            {user && Object.keys(user).length > 0 && (
              <ListItem button divider onClick={goToChangePassword}>
                <ListItemIcon>
                  <VpnKeyIcon className={classes.listItemIcon} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  className={classes.listItemText}
                  primary={<FormattedMessage id="LABELS.COMMONS.CHANGE_PASSWORD" />}
                />
              </ListItem>
            )}
            {user && user.empresas && user.empresas.length > 1 && (
              <ListItem button divider onClick={goToChangeCompany}>
                <ListItemIcon>
                  <BusinessIcon className={classes.listItemIcon} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  className={classes.listItemText}
                  primary={<FormattedMessage id="LABELS.COMMONS.CHANGE_COMPANY" />}
                />
              </ListItem>
            )}
            <ManualButton
              rest={{
                menu: true,
                type: SYSTEM_DOC_TYPES.EXTERNO.key,
              }}
            />
            <ListItem button divider onClick={handleLogOut}>
              <ListItemIcon>
                <PowerSettingsNew className={classes.listItemIcon} />
              </ListItemIcon>
              <ListItemText
                disableTypography
                className={classes.listItemText}
                primary={<FormattedMessage id="LABELS.COMMONS.EXIT" />}
              />
            </ListItem>
          </>
        )}
      </List>
    );
  };

  const renderUserInfo = () => {
    return (
      <div className={classes.user}>
        <Typography color="primary" variant="body1" classes={{ colorPrimary: classes.userText }}>
          {name}
        </Typography>
        <Typography color="primary" variant="caption" classes={{ colorPrimary: classes.userText }}>
          {email}
        </Typography>
      </div>
    );
  };

  const renderPopover = () => {
    return (
      <Popover
        open={open}
        anchorEl={anchorEl}
        anchorReference="anchorEl"
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        disableEnforceFocus
      >
        <div className={classes.popoverContent}>
          {!!auth.getToken() && renderUserInfo()}
          {renderActionsList(classes)}
        </div>
      </Popover>
    );
  };

  return (
    <React.Fragment>
      <IconButton color="primary" onClick={handlePopover}>
        <TuneIcon />
      </IconButton>

      {renderPopover()}
    </React.Fragment>
  );
}

export default injectIntl(UserPopover);
